module.exports = __webpack_public_path__ + "static/img/image@1x-6.ed70ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/image@1x-6.png
// module id = /FUF
// module chunks = 0